import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import Datatable from "components/Datatables/datatable"
import { clientOptions } from "store/actions"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dispath } from "constants/layout"
import { post } from "helpers/api_helper"
import Maincard from "./components/maincard";

const isType = 'Order By Clients'
const styleSheet = {
    fontStyle: {
        fontWeight: 'bold',
        background: '#424141',
        padding: '0px 15px',
        color: '#fff'
    }
}

const Noorderclients = () => {
    const [rowData, setRowData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [countData, setCountData] = useState([])
    const [filterData, setFilterData] = useState({
        'startdate': new Date(),
        'enddate': new Date(),
        'type': 0
    });

    // table Column Data
    let tableColumns = [
        {
            dataField: 'id',
            text: '#',
            sort: true,
            formatter: (cell, row,  rowIndex, extraData) => rowIndex+1
        },{
            dataField: 'clientname',
            text: 'Client',
            sort: false
        },{
            dataField: 'client_code',
            text: 'Code',
            sort: false
        },{
            dataField: 'mobile',
            text: 'Mobile',
            sort: false
        },{
            dataField: 'total_orders',
            text: 'Orders',
            sort: true
        }
    ];

    const submitCall = async() => {
        setRowData(null)
        setIsLoading(true)
        const { success, items } = await post(`api/reports/clientorders`, filterData);
        if(success){
            setRowData(items);
            // const a = items?.reduce(
            //     (acc, v) => {
            //         if (v.total_orders == 0) {
            //         acc.NoOrders.push(v);
            //         } else if (v.total_orders >= 10 && v.total_orders <= 25) {
            //         acc.Min10t25.push(v);
            //         } else if (v.total_orders > 25 && v.total_orders <= 50) {
            //         acc.min25t50.push(v);
            //         } else if (v.total_orders > 50 && v.total_orders <= 75) {
            //         acc.MoreT50.push(v);
            //         } else if (v.total_orders > 75) {
            //         acc.TOPC.push(v);
            //         }
            //         return acc;
            //     },
            //     { NoOrders: [], Min10t25: [], min25t50: [], MoreT50: [], TOPC: [] }
            // );

            const counts = items?.reduce(
                (acc, v) => {
                    if (v.total_orders == 0) {
                    acc.NoOrders++;
                    } else if (v.total_orders >= 10 && v.total_orders <= 25) {
                    acc.Min10t25++;
                    } else if (v.total_orders > 25 && v.total_orders <= 50) {
                    acc.Min25t50++;
                    } else if (v.total_orders > 50 && v.total_orders <= 75) {
                    acc.MoreT50++;
                    } else if (v.total_orders > 75) {
                    acc.TopClients++;
                    }
                    return acc;
                },
                { NoOrders: 0, Min10t25: 0, Min25t50: 0, MoreT50: 0, TopClients: 0 }
            );

            // Convert to display-friendly array
            const displayData = [
                { title: "Clients with No Orders", key: "noOrders", value: counts.NoOrders },
                { title: "Clients with \n 10–25 Orders", key: "min10t25", value: counts.Min10t25 },
                { title: "Clients with 26–50 Orders", key: "min25t50", value: counts.Min25t50 },
                { title: "Clients with 51–75 Orders", key: "moreT50", value: counts.MoreT50 },
                { title: "Top Clients (75+ Orders)", key: "topClients", value: counts.TopClients },
            ];

            setCountData(displayData);

            setIsLoading(false)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags> <title>Dashboard | {isType}</title> </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Reports" breadcrumbItem={isType} />
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={3} className={'mb-3'}>
                                            <label>Start Date</label>
                                            <DatePicker className="form-control" selected={filterData.startdate || new Date()} onChange={(date) => setFilterData(prev => ({...prev, startdate: date}))} />
                                        </Col>
                                        <Col md={3} className={'mb-3'}>
                                            <label>End Date</label>
                                            <DatePicker className="form-control" minDate={filterData.startdate} selected={filterData.enddate || new Date()} onChange={(date) => setFilterData(prev => ({...prev, enddate: date}))} />
                                        </Col>
                                        <Col md={1} style={{marginTop: '24px'}}>
                                            <button className="btn btn-primary float-end" onClick={() => submitCall()} disabled={isLoading} > Submit</button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Maincard cardItems={countData} loading={isLoading} colSize={2} mainCol={12}/>

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatable
                                        keyField={'client_code'}
                                        title={`All ${isType}`}
                                        isAdd={false}
                                        is_remote={false}
                                        handleAddButton=''
                                        localSearch={true}
                                        columns={tableColumns}
                                        rowsLength={rowData?.length || 0}
                                        rows={rowData || []}
                                        loading={isLoading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Noorderclients
